import Vue from 'vue';
import { EnterToBlurDirective, BlurToEnterDirective } from './enterBlur';
import { ClickIgnoreDrag } from './clickIgnoreDrag';

Vue.directive('enter-to-blur', EnterToBlurDirective);
Vue.directive('blur-to-enter', BlurToEnterDirective);
Vue.directive('click-ignore-drag', ClickIgnoreDrag);
